import { ref } from 'vue'

export const usePagination = () => {
	const infoItems = ref<any[]>([])
	const atualStartIndex = ref(0)
	const atualEndIndex = ref(0)
	const quantityPerPage = ref(0)

	function setStartEnd(startIndex: number) {
		atualStartIndex.value = startIndex
		atualEndIndex.value = startIndex + quantityPerPage.value
	}

	function setQuantityPerPage(value: number) {
		quantityPerPage.value = value
	}

	return {
		infoItems,
		atualStartIndex,
		atualEndIndex,
		quantityPerPage,
		setStartEnd,
		setQuantityPerPage,
	}
}
